import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "facebook"
const FacebookIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 2C17.523 2 22 6.505 22 12.062 22 17.083 18.343 21.243 13.563 21.998V14.971H15.893L16.336 12.06H13.563V10.175C13.563 9.379 13.949 8.602 15.192 8.602H16.453V6.126S15.31 5.93 14.214 5.93C11.932 5.93 10.438 7.322 10.438 9.845V12.062H7.898V14.97H10.437V21.998C5.658 21.243 2 17.083 2 12.062 2 6.505 6.477 2 12 2" />
        </svg>
      }
    </span>
  )
}
export default FacebookIcon
